import { Card } from '../components/ui/Card';
import { CodeSnippet } from '../components/ui/CodeSnippet';
import { TechSelector } from '../components/ui/TechSelector';

import { useAccountNumber } from '/src/hooks';
import { VideoPlayer } from '/src/components/VideoPlayer';
import { ListItem } from '../components/ui/ListItem';
import { SupportLink } from '../../_global/components/SupportLink';
import { SupportLinks } from '/src/support';

import MagentoPoster from '/src/features/installation/assets/magento2-instructions-poster.jpg';
import MagentoVideo from '/src/features/installation/assets/magento2-instructions.mp4';

export function Magento2Instructions({
  techOptions = [],
  selectedTechOption = null,
  onSelectTech,
  onContactDeveloper,
}) {
  const [accSegment1, accSegment2] = useAccountNumber(true);

  return (
    <Card className="max-w-[720px] w-full mt-5 mb-6">
      <div className="mb-4 flex w-full flex-col gap-3 md:flex-row md:items-center">
        <h2 className="flex-1 text-lg font-bold leading-9 text-black-pearl-500">Instructions</h2>
        <TechSelector techOptions={techOptions} selectedTechOption={selectedTechOption} onSelectTech={onSelectTech} />
      </div>

      <ol className="flex flex-col gap-4 mb-4">
        <ListItem number={1}>Log in to your Magento account, and open your admin panel.</ListItem>

        <ListItem number={2}>
          In the panel on the left, click on <strong>Content &gt; Configuration.</strong>
        </ListItem>

        <ListItem number={3}>
          Find the store view that you want to configure. Then, in the <strong>Action</strong> column, click{' '}
          <strong>Edit.</strong>
        </ListItem>

        <ListItem number={4}>
          Click to expand the <strong>HTML Head</strong> section.
        </ListItem>

        <ListItem number={5}>
          Copy and paste the Crazy Egg tracking script below into the <strong>Scripts and Style Sheets</strong> text
          box.
        </ListItem>
      </ol>

      <CodeSnippet
        code={`<script type="text/javascript" src="//script.crazyegg.com/pages/scripts/${accSegment1}/${accSegment2}.js" async="async"></script>`}
        showMailButton
        onMailButtonClick={onContactDeveloper}
      />

      <ol className="flex flex-col gap-4 mt-4">
        <ListItem number={6}>
          Click on the <strong>Save Configuration</strong> button.
        </ListItem>
      </ol>

      <div className="my-5 rounded bg-white-lilac-500 px-6 py-5 text-black-pearl-500">
        <strong className="text-body-1 text-black-pearl-500">Note:</strong> If you are using a cache plugin on your
        site, you will need to clear it after you have installed your Crazy Egg code.
      </div>

      <p className="mt-10 text-base font-normal leading-6 text-black-pearl-500 mb-3">
        Watch this video to see these steps:
      </p>

      <VideoPlayer src={MagentoVideo} poster={MagentoPoster} label="Magento 2 installation video" />

      <div className="flex flex-col gap-1 mt-3">
        <SupportLink
          href={SupportLinks.install.magento2}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Magento 2 Setup Guide
        </SupportLink>
        <SupportLink
          href={SupportLinks.general.newSupportRequest}
          className="text-sm sm:text-base font-bold leading-6 text-dodger-blue-500 hover:underline"
        >
          Contact Support
        </SupportLink>
      </div>

      <p className="mt-3 text-black-pearl-500">
        Click on <strong>Check installation</strong> once you have connected Crazy Egg with Magento 2.
      </p>
    </Card>
  );
}
